<template>
  <div class="top-0 right-0 left-0 z-10 mt-4">
    <div class="w-full mx-auto flex justify-between h-16 items-center">
      <div class="h-full w-1/3 text-center flex justify-left items-center">
        <a href="/" class="w-10 h-10">
          <img src="/images/Cardstock_Mark.png" alt="">
        </a>
      </div>
      <div class="hidden md:flex flex-grow flex justify-end">
        <router-link
          :to="{ name: 'search' }"
          class="text-blue-800 px-2 text-base ml-4 h-10 w-24 rounded flex justify-center border items-center
          focus:outline-none
          hover:bg-blue-200"
          tag="button"
        >
          <font-awesome-icon class="text-2xl inline-block mr-2" :icon="['fal', 'search']"/>
          <span>
            Search
          </span>
        </router-link>
        <Modal>
          <template slot="modal__button" slot-scope="{didOpen}">
            <button @click="didOpen" class="
              text-blue-800 px-2 text-base ml-4 h-10 w-24 rounded flex justify-center border items-center
              focus:outline-none
              hover:bg-blue-200
            ">
              <font-awesome-icon class="text-2xl mr-2" :icon="['fal', 'comment']"/>
              <div>
                Text
              </div>
            </button>
          </template>
          <template slot="modal__body">
            <div class="py-2 w-128">
              <div class="text-center mb-4 text-xl">
                New Message to...
              </div>
              <MessageRecipientForm
                :teamId="teamId"
              />
            </div>
          </template>
        </Modal>
        <!-- <button class="
          text-blue-800 px-2 text-base ml-4 h-10 rounded w-10
          focus:outline-none
          hover:bg-blue-200
        ">
          <font-awesome-icon class="text-2xl" :icon="['fal', 'phone']"/>
        </button> -->
        <router-link
          :to="{ name: 'blastNew' }"
          class="text-blue-800 px-2 text-base ml-4 h-10 w-24 rounded flex justify-center border items-center
          focus:outline-none
          hover:bg-blue-200"
          tag="button"
        >
          <font-awesome-icon class="text-2xl inline-block mr-2" :icon="['fal', 'bullhorn']"/>
          <span>
            Blast
          </span>
        </router-link>
        <PanelDropdown
          :items="[
            {text: 'Settings', to: {name: 'settings'}},
            {text: 'Logout', to: {name: 'logout'}}
          ]"
          size="small"
        >
          <template slot="panel-dropdown__button">
            <button class="text-blue-800 px-2 text-base ml-4 h-10 w-24 rounded flex justify-center content-center border items-center focus:outline-none hover:bg-blue-200">
              <font-awesome-icon class="text-2xl mr-2" :icon="['fal', 'user']"/>
              <span>You</span>
            </button>
          </template>
        </PanelDropdown>
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown.vue'
import Container from '@/components/Container.vue'
import MessageRecipientForm from '@/components/MessageRecipientForm.vue'
import Modal from '@/components/Modal.vue'
import PanelDropdown from '@/components/PanelDropdown.vue'

export default {

  components: {
    Container,
    Dropdown,
    Modal,
    PanelDropdown,
    MessageRecipientForm
  },

  props: ['currentUser', 'teamId']

}
</script>
